import { HttpRequest } from '@angular/common/http';

const whitelist = [
  '/api/authentication/sign-in/refresh',
  '/api/authentication/sign-out',
];

export function isWhitelistHttpRequest(
  httpRequest: HttpRequest<unknown>,
): boolean {
  return whitelist.some((e) => httpRequest.url.includes(e));
}

export function shouldRedirectToSignIn(
  httpRequest: HttpRequest<unknown>,
): boolean {
  return !httpRequest.url.includes('/api/users/me');
}
